/**
 * A source-of-truth list of all Gathr brands, with associated URL subdomains, etc.
 */

// NOTE: for local development, each of these subdomains needs a hosts alias
// such that 127.0.0.1 can map to {sub}.rootdomain.com, as well
// as a top-level rootdomain.com in the same manner
export const brands = [
  {
    name: 'orca',
    subdomain: 'orcacoolers',
    title: 'ORCA',
  },
  {
    name: 'klymit',
    subdomain: 'klymit',
    title: 'Klymit',
  },
  {
     name: 'gci',
     subdomain: 'gcioutdoor',
     title: 'GCI Outdoor',
  },
  // {
  //   name: 'cvt',
  //   subdomain: 'cascadiatents',
  //   title: 'Cascadia Vehicle Tents',
  // },
  // {
  //   name: 'rightline',
  //   subdomain: 'aaa',
  //   title: 'Rightline Gear',
  // },
  // {
  //   name: 'waterport',
  //   subdomain: 'bbb',
  //   title: 'WaterPORT',
  // },

  // {
  //   name: 'pridesports',
  //   subdomain: 'ccc',
  //   title: 'PrideSports',
  // },
];
